import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs';
import { HttpClientService } from '../../../../_shared/services/http-client.service';
import { HelperService } from '../../../../_shared/services';
import { Document } from '../../../../_shared/model';

@Injectable({
    providedIn: 'root',
})
export class DocumentsService {
    constructor(private httpClient: HttpClientService, private helper: HelperService) {}

    public getDocumentsVR(reservationId: string, visitId?: number): Observable<Document[]> {
        if (visitId) {
            return this.getDocumentsForVisit(visitId);
        } else {
            return this.getDocumentsForReservation(reservationId);
        }
    }

    public getDocumentsForReservation(reservationId: string): Observable<Document[]> {
        return this.httpClient.get(this.helper.getApiUrl() + '/reservations/' + reservationId + '/documents').pipe(
            map((val) => {
                return val.documents;
            }),
        );
    }

    public getDocumentsForVisit(visitId: number): Observable<Document[]> {
        return this.httpClient.get(this.helper.getVisitUrl() + '/visits/' + visitId + '/documents').pipe(
            map((val) => {
                return val.documents;
            }),
        );
    }
}
